import React from 'react'

const Personalisation = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/personalisation',
  ...props
}) => (
  <svg height='40' width='40' viewBox='0 0 40 40' style={style} {...props}>
    <g stroke={primaryColor} fill='none' fillRule='evenodd' strokeLinecap='square'>
      <path d='M21 9.5h14M5 9.5h7M12.5 5.5h5v8h-5zM21 31.5h14M5 31.5h7M12.5 27.5h5v8h-5zM32 20.5h3M5 20.5h18M23.5 16.5h5v8h-5z' />
    </g>
  </svg>
)

export default Personalisation
